import {
  IEventCollectionData,
  IEventCollectionDataActiveEvents,
  IEventCollectionDataActiveTypeticketcollections,
  IEventCollectionMetadata,
} from 'meta/pages/v4/eventCollection'
import { SliceSelector } from 'store/types'

import { getCollectionKey } from '../_utils'

const getCollectionDetails: SliceSelector<IEventCollectionData | undefined, { id: string; language: string }> =
  ({ id, language }) =>
  (state) =>
    state.pages.collection[getCollectionKey({ id, language })]?.details

const getCollectionBulkDetails: SliceSelector<
  IEventCollectionData[] | undefined,
  { codes: string[]; language: string }
> =
  ({ codes, language }) =>
  (state) => {
    return codes
      .map((code) => state.pages.collection[getCollectionKey({ id: code, language })]?.details)
      .filter(Boolean) as IEventCollectionData[]
  }

const getCollectionActiveEvents: SliceSelector<
  | {
      data: Record<number, IEventCollectionDataActiveEvents>
      metadata: IEventCollectionMetadata
    }
  | undefined,
  { id: string; language: string }
> =
  ({ id, language }) =>
  (state) =>
    state.pages.collection[getCollectionKey({ id, language })]?.activeEvents

const getCollectionEvents: SliceSelector<
  | {
      data: Record<number, IEventCollectionDataActiveEvents>
      metadata: IEventCollectionMetadata
    }
  | undefined,
  { id: string; language: string }
> =
  ({ id, language }) =>
  (state) =>
    state.pages.collection[getCollectionKey({ id, language })]?.events

const getCollectionActiveTypeticketcollections: SliceSelector<
  | {
      data: Record<number, IEventCollectionDataActiveTypeticketcollections>
      metadata: IEventCollectionMetadata
    }
  | undefined,
  { id: string; language: string }
> =
  ({ id, language }) =>
  (state) =>
    state.pages.collection[getCollectionKey({ id, language })]?.activeTypeticketcollections

export const CollectionSelectors = {
  getCollectionDetails,
  getCollectionBulkDetails,
  getCollectionActiveEvents,
  getCollectionEvents,
  getCollectionActiveTypeticketcollections,
}
